import React from "react";
import autoBind from "react-autobind";
import { root } from "baobab-react/higher-order";

import WebPlayerInternal from "./WebPlayerInternal";
import state from "../../state";
import * as playerActions from "../../actions/playerActions";

class WebPlayer extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
		this.rootedComponent = root(state, WebPlayerInternal);
		console.log("WEB PLAYER CONSTRUCTOR");
	}

	render() {
		return <this.rootedComponent {...this.props} />;
	}

	setStateValue(path, value) {
		state.set(path, value);
	}

	getStateValue(path) {
		return state.get(path);
	}

	async saveActivity() {
		return playerActions.saveActivity();
	}
}

export default WebPlayer;